import { Component, Input, OnInit, OnChanges } from '@angular/core';
import moment from 'moment';
import 'moment/locale/de';
import {SharedModule} from '../../../../../core/modules/shared.module';
import {EventService} from '../../../../../core/services/event.service';
declare var google: any;
moment.locale('de');

@Component({
    selector: 'event-description-component',
    templateUrl: './event-description.component.html',
    styleUrls: ['./event-description.component.scss'],
    standalone: true,
  imports: [SharedModule]
})
export class EventDescriptionComponentNew implements OnInit, OnChanges {
  @Input() event;
  @Input() readData;
  @Input() participant = 0;

  opacityColor;
  _date;
  date;
  location;
  organization;
  manager;
  weblinks = [];
  targetGroups = [];
  levels = [];
  skills = [];
  time;

  constructor(public eventService: EventService) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    if (this.event) {
      let _dates = '';
      if (this.event.dates) {
        let divider = ', ';
        if (this.event.datesType === 'oneDay') {
          divider = '';
        }
        if (this.event.datesType === 'longEvent') {
          divider = ' - ';
        }
        if (this.event.datesType === 'fewDays') {
          divider = '/ ';
        }
        if (this.event.datesType === 'repeatEvent') {
          divider = ', ';
        }
        let _data = this.event.dates;
        _data.forEach(el => {
          if (_dates) {
            _dates =
              _dates +
              divider +
              this.getDateByType(el);
          } else {
            _dates = this.getDateByType(el);
          }
        });
        if (this.event.datesType === 'oneDay' || this.event.datesType === 'longEvent') {
          if (_data.length > 0) {
            let _time = [];
            if (_data[0].startTime) {
              _time.push(moment(_data[0].startTime).format('HH:mm'));
            }
            if (_data[0].endTime) {
              _time.push(moment(_data[0].endTime).format('HH:mm'));
            }
            this.time = _time.join(' - ');
          }
        }
      }

      this.date = _dates;
      if (this.event.location) {
        this.geoCodeLatLng(
          this.event.location.split(',')[0],
          this.event.location.split(',')[1]
        );
      } else {
        this.location = '';
      }
      if (this.event.weblinks) {
        this.weblinks = this.event.weblinks;
      } else {
        this.weblinks = [];
      }
      this.opacityColor = this.hexToRGB(this.event.eventType.color, 0.8);
      if (this.event.dates) {
        const dateArr = this.event.dates;
        if (dateArr.length) {
          this._date = moment(dateArr[0].date).format('DD. MMM YY');
        } else {
          this._date = '';
        }
      } else {
        this._date = '';
      }
      this.targetGroups = this.event.targetGroupData;
      this.levels = this.event.eventLevelData;
      this.skills = this.event.skillsData;
    }
  }

  getDateByType(date) {
    if (this.event.datesType === 'oneDay' || this.event.datesType === 'longEvent') {
      return moment(date.date).format('dddd, DD. MMMM');
    }
    if (this.event.datesType === 'fewDays' || this.event.datesType === 'repeatEvent') {
      let _time = [];
      if (date.startTime) {
        _time.push(moment(date.startTime).format('HH:mm'));
      }
      if (date.endTime) {
        _time.push(moment(date.endTime).format('HH:mm'));
      }
      if (_time.length) {
        return moment(date.date).format('dddd, DD. MMMM') + ' (' + _time.join(' - ') + ')';
      }
      return moment(date.date).format('dddd, DD. MMMM');
    }
  }

  public geoCodeLatLng(lat, lng) {
    const that = this;
    const geoCoder = new google.maps.Geocoder();
    const latlng = { lat: +lat, lng: +lng };
    geoCoder.geocode({ location: latlng }, function(results, status) {
      if (status === 'OK') {
        that.location = results[0].formatted_address;
      } else {
        that.location = '';
      }
    });
  }

  hexToRGB(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    } else {
      return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    }
  }

  getEventImage(name) {
    return this.eventService.getFileStream(name);
  }
}
